
import React, { useEffect, useState } from 'react';
import { Box, Container, Tabs, Tab, Typography } from "@mui/material"
import Layout from "../components/Layout"
import { OwnerSpace } from "../components/OwnerSpace"
import { PetSpaceComponent } from "../components/PetSpaceComponent"
import { PetAPI } from '../api/PetAPI';

export const PetSpace = () => {
    const [value, setValue] = useState(0);
    const [pets, setPets] = useState([]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const loadData = async () => {
        const response = await PetAPI.getPets();
        if (response.success) {
            setPets(response.data.pets || []);
        }
    }
    useEffect(() => {
        loadData();
    }, []);
    return (
        <Layout height="calc(100vh - 100px)">
            <Box marginBottom='10px' width="100%">
                <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    Área Pet
                </Typography>
                <Tabs value={value} onChange={handleChange} aria-label="config-tabs">
                    <Tab label="Dono" />
                    <Tab label="Pet" />
                </Tabs>
            </Box>
            
            {value === 0 && <OwnerSpace pets={pets} />}
            {value === 1 && <PetSpaceComponent />}
        </Layout>
    )
}
